import OcdpAPI from "@providers/OcdpAPI";
import { Numbers } from "@utils/Numbers";

export const OperandTexts = {
  eq: "IGUAL A",
  neq: "DIFERENTE DE",
  gt: "MAIOR QUE",
  gte: "MAIOR OU IGUAL A",
  lt: "MENOR QUE",
  lte: "MENOR OU IGUAL A",
  bt: "ENTRE",
  in: "DENTRE",
  like: "CONTÉM",
  starts: "INICIA COM",
  ends: "TERMINA COM",
};

export const LogicalOperandTexts = {
  and: "E",
  or: "OU",
};

export class Oraculo {
  static operandLabel(field, operand, { value, range }) {
    const range_field = [
      "c.birthdate",
      "cc.used_at",
      "cc.expires_at",
      "cc.remind_gain_date",
      "p.created_at",
      "c.created_at",
      "c.updated_at",
      "c.last_conversion",
      "o.created_at",
      "c.created_at_hour",
      "c.created_at_week",
      "c.created_at_year",
    ];

    if (range_field.includes(field)) {
      switch (range.type) {
        case "in_last":
          return "ÚLTIMOS";
        case "more_than":
          return "A MAIS DE";
        case "time_to":
          return "EM";
        case "current_period":
          return range.is_not ? "EXCETO ESTE" : "NESTE";
        case "range":
          return OperandTexts.bt;
      }
      return OperandTexts[operand];
    }

    return OperandTexts[operand];
  }

  static formatByField(field, { label, value, range }) {
    const currency_fields = [
      "c.sum_order",
      "o.order_total",
      "o.delivery_total",
      "c.average_order",
      "cc.min_order",
      "p.total",
    ];

    const label_fields = [
      "o.unit_id",
      "o.brand_id",
      "w.condition",
      "o.week_day",
      "o.month",
      "c.rfv_profile",
      "c.created_at_weekday",
      "c.consent",
      "c.created_at_month",
      "cc.used_at_weekday",
      "cc.used_at_month",
      "p.created_at_month",
      "p.created_at_weekday",
    ];

    const celcius_fields = ["w.temperature", "w.feelslike"];

    const percent_fields = ["w.humidity"];

    const number_fields = ["c.quantity", "c.days_without_conversion"];

    const range_fields = [
      "c.birthdate",
      "cc.used_at",
      "cc.expires_at",
      "cc.remind_gain_date",
      "p.created_at",
      "c.created_at",
      "c.updated_at",
      "c.last_conversion",
      "o.created_at",
      "c.created_at_hour",
      "c.created_at_week",
      "c.created_at_year",
    ];

    if (currency_fields.includes(field)) {
      return Numbers.currency(value);
    }

    if (label_fields.includes(field)) {
      return label;
    }

    if (celcius_fields.includes(field)) {
      return `${Numbers.number(value, 2)}°`;
    }

    if (percent_fields.includes(field)) {
      return Numbers.formatPercent(value, 2);
    }

    if (number_fields.includes(field)) {
      return Numbers.number(value, 0);
    }

    if (range_fields.includes(field)) {
      const getPeriod = (r) => {
        const is_plural = r.min > 0;
        switch (r.period) {
          case "day":
            return (is_plural && "dias") || "dia";
          case "month":
            return (is_plural && "meses") || "mês";
          case "year":
            return (is_plural && "anos") || "ano";
        }
      };

      switch (range.type) {
        case "in_last":
          return Numbers.number(range.min, 0) + " " + getPeriod(range);
        case "more_than":
          return Numbers.number(range.min, 0) + " " + getPeriod(range);
        case "time_to":
          return Numbers.number(range.min, 0) + " " + getPeriod(range);
        case "current_period":
          return getPeriod(range);
        case "range":
          return `${range.min} e ${range.max}`;
        default:
          return range.min;
      }
    }

    return label || value;
  }

  static formatValue(type, operand, { label, value, range }) {
    if (operand == "bt") {
      const _values = value.map((v) =>
        Oraculo.formatByField(type, { value: v })
      );
      return _values.join(" e ");
    }

    return Oraculo.formatByField(type, { label, value, range });
  }

  static async waitQueryExecution(execution_id) {
    const ocdp = new OcdpAPI();

    return await new Promise((resolve) => {
      const interval_id = setInterval(async () => {
        const status = await ocdp.status(execution_id);
        if (status != "RUNNING") {
          clearInterval(interval_id);
          resolve({ execution_id, status });
        }
      }, 1000);
    });
  }

  static async export(execution_id, audience_id, filters = [], type = "xls") {
    const ocdp = new OcdpAPI();

    const exec = await ocdp.export(execution_id, audience_id, filters);
    const { job_id, link } = exec;

    if (!link) {
      return null;
    }

    const mount_response = ({ job_id, status }) => ({ job_id, status, link });

    return await new Promise((resolve) => {
      const interval_id = setInterval(async () => {
        const status = await ocdp.export_status(job_id);
        if (status != "RUNNING") {
          clearInterval(interval_id);
          resolve(mount_response({ job_id, status }));
        }
      }, 1000);
    });
  }
}
